import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=57a8b573&scoped=true"
import script from "./UserDashboard.vue?vue&type=script&lang=js"
export * from "./UserDashboard.vue?vue&type=script&lang=js"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=57a8b573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a8b573",
  null
  
)

export default component.exports